import * as actionTypes from './actionTypes'
import {
    fetchWithCookieRefresh, handleResponseError,
} from '../../../utils'


export const setImageData = (data) => ({
    type: actionTypes.SET_IMAGE_DATA,
    data: data,
})

export const imageSearchGet = (image_id) => {
    let args = `?image_id=${image_id}`

    return (dispatch, getState) => {
        // return fetchWithCookieRefresh('/api/image_search_get.json', {
        return fetchWithCookieRefresh('/api/image_search/search_image/get' + args, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(data => {
            console.log("/api/image_search/search_image/get data = ", data);
            return data.data
        })
        .catch(error => {
            throw error
        })
    }
}
